import { render, staticRenderFns } from "./UploadImageTable.vue?vue&type=template&id=6b44c66c&scoped=true&"
import script from "./UploadImageTable.vue?vue&type=script&lang=js&"
export * from "./UploadImageTable.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageTable.vue?vue&type=style&index=0&id=6b44c66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44c66c",
  null
  
)

export default component.exports